/**
 * NavigationMenu - Clean desktop navigation inspired by Shopify
 * 
 * Features:
 * - Simplified navigation: Shop, Track, Help
 * - Uses shadcn NavigationMenu for accessibility
 * - Clean visual design with hover states
 * - Progressive disclosure based on user authentication
 */

import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface NavigationMenuProps {
  className?: string;
}

export const NavigationMenu = memo<NavigationMenuProps>(({ className = '' }) => {

  return (
    <nav className={`flex items-center space-x-6 ${className}`}>
      <Link to="/catalog" className="group">
        <Button variant="ghost" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
          Catalog
        </Button>
      </Link>
      
      <Link to="/quote" className="group">
        <Button variant="ghost" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
          Get Quote
        </Button>
      </Link>
    </nav>
  );
});

NavigationMenu.displayName = 'NavigationMenu';

export default NavigationMenu;